export enum CourseModality {
  STANDARD = 'standard',
  FLASH = 'flash',
  FP = 'fp',
  MASTER = 'master'
}
